$(function () {
    var $document = $(document);

    $('.popper').dialog({
            height: 'auto',
            width: $(window).width() > 800 ? 800 : 'auto', //sets the initial size of the dialog box
            fluid: true,
            modal: true,
            title: "Inscription",
            buttons: [
                {
                    text: "OK",
                    click: function () {
                        $(this).dialog("close");
                    }
                }
            ]
        }
    );

    $(document).sortable();

    /**
     * Active jQuery Chosen sur les <select>.
     */
    $('.chosen-select').chosen({
        disable_search_threshold: 10,
        allow_single_deselect: true,
        width: '100%'
    });

    /**
     * Autosubmit lorsque la valeur du <select> change.
     */
    $('#customerSelect').find('select').on('change', function () {
        $(this).closest('form').submit();
    });

    /**
     * Event details
     */
    $('body').on('click', '.event-details-btn', function () {
        $(this).next('.event-details').toggleClass('hidden');
    });

    /**
     * Modal d'ajout de notes.
     */
    /*var $modal = $('#writeNote');

    $(document).on('click', '[data-target="#writeNote"]', function () {

        var note = document.querySelector('#writeNote'),
            id = this.getAttribute('data-note-id'),
            source = this;

        // Récupère le contenu de la note existante.
        if (id) {
            $.ajax({
                url: Routes.getNote + '/' + id,
                type: 'GET',
                success: function (response) {
                    note.querySelector('textarea[name="content"]').value = response;
                }
            });
        } else {
            // Sinon, vide le <textarea>
            note.querySelector('textarea[name="content"]').value = '';
        }

        $modal.find('.modal-title').text(source.getAttribute('data-date'));
        $modal.find('[name="id"]').val(/^\d+$/.test(source.getAttribute('data-note-id')) ? source.getAttribute('data-note-id') : null);
        $modal.find('[name="menu_id"]').val(source.getAttribute('data-menu-id'));
        $modal.find('[name="user_id"]').val(source.getAttribute('data-user-id'));
        $modal.data('source', source);
    });

    $modal.on('click', '.submit', function (response) {
        $.ajax({
            url: Routes.postNote,
            type: 'PUT',
            data: $modal.find('form').serialize(),
            success: function (response) {
                $modal.data('source').setAttribute('data-note-id', response);
                $modal.modal('hide');
            }
        });
    });*/
});
